export default "__VITE_ASSET__CpB6FIKl__"